import { FC, useReducer } from 'react';

import { Download } from 'lucide-react';

import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { BoxesDistributionDialog } from './boxesDistributionDialog/BoxesDistributionDialog';
import { ExportTournamentResultsDialog } from './exportTournamentResultsDialog/ExportTournamentResultsDialog';

import css from './TournamentsHistoryActionsColumn.module.css';

import { TournamentModel } from 'v2/types/TournamentModel';

interface TournamentsHistoryActionsColumn {
  tournament: TournamentModel;
  onRevalidate: VoidFunction;
}

export const TournamentsHistoryActionColumn: FC<TournamentsHistoryActionsColumn> = ({ tournament, onRevalidate }) => {
  const [isBoxesDialogOpen, setBoxesDialogOpen] = useReducer((state) => !state, false);
  const [isExportDialogOpen, setExportDialogOpen] = useReducer((state) => !state, false);

  return (
    <div className={css.tournamentsHistoryActionsColumn}>
      <Tooltip title="Export" placement="top">
        <IconButton color="primary" onClick={setExportDialogOpen}>
          <Download width={20} height={20} />
        </IconButton>
      </Tooltip>

      <BoxesDistributionDialog
        tournament={tournament}
        isOpen={isBoxesDialogOpen}
        onClose={setBoxesDialogOpen}
        onRevalidate={onRevalidate}
      />

      <ExportTournamentResultsDialog
        tournament={tournament}
        isOpen={isExportDialogOpen}
        onClose={setExportDialogOpen}
      />
    </div>
  );
};
